/**
 * Map an app route to the matching section anchor in the V1 user manual.
 * Anchor slugs match the slugify() in HelpPage.jsx (lowercase, & → "and",
 * non-alnum stripped, spaces → hyphens).
 *
 * Returns the anchor slug (without leading '#') or null when no specific
 * section maps to that route (caller should just open /help at the top).
 */
const ROUTE_MAP = [
  // exact-match first (most specific wins)
  ['/help', null],
  ['/map', '6-live-map'],
  ['/vehicles', '8-vehicles'],
  ['/school-bus', 'students-school-bus-standard'],
  ['/work-templates', '10-work-board'],
  ['/work', '10-work-board'],
  ['/geofences', '11-geofences-and-pois'],
  ['/pois', '11-geofences-and-pois'],
  ['/alerts', '5-alerts-and-rules-engine'],
  ['/maintenance', '12-drivers-and-maintenance'],
  ['/drivers', '12-drivers-and-maintenance'],
  ['/reports/idling', '26-engine-signals'],
  ['/reports/maintenance-due', '12-drivers-and-maintenance'],
  ['/reports/cold-chain', '23-cold-chain'],
  ['/cold-chain', '23-cold-chain'],
  ['/reports', '9-reports'],
  ['/forms', '13-forms-inspections'],
  ['/people', '14-people-staff-and-safety'],
  ['/attendance', '14-people-staff-and-safety'],
  ['/safety', '14-people-staff-and-safety'],
  ['/chat', '15-chat'],
  ['/intelligence', '16-intelligence-ai'],
  ['/sultan', '18-instance-admin-panel'],
  ['/analytics', '18-instance-admin-panel'],
  ['/settings/maintenance', '12-drivers-and-maintenance'],
  ['/settings', '17-settings'],
  ['/replay', '6-live-map'],
  ['/', '7-dashboard'],
];

export function routeToHelpSlug(pathname) {
  if (!pathname) return null;
  for (const [prefix, slug] of ROUTE_MAP) {
    if (prefix === '/') {
      if (pathname === '/') return slug;
    } else if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return slug;
    }
  }
  return null;
}

export function helpUrlForRoute(pathname) {
  const slug = routeToHelpSlug(pathname);
  return slug ? `/help#${slug}` : '/help';
}
